import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {signinwallConfig,signinwallBmg,signinwallBmgs,signinwall,signinwallMessage,signinwallMessageRecents,signinwallMessageRecent} = api

/**
 * 查找
 */
export async function findSigninwallConfig(params) {
    return request({url: signinwallConfig, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function findSigninwallBmg(params) {
    return request({url: signinwallBmgs, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function updateSigninwall(params) {
    return request({url: signinwall, method: 'put', data: params,})
}

/**
 * 创建
 */
export async function createSigninwallBmg(params) {
    return request({url: signinwallBmgs, method: 'post', data: params,})
}

/**
 * 删除
 */
export async function deleteSigninwallBmg(params) {
    return request({url: signinwallBmg, method: 'delete', data: params,})
}

/**
 * 发送留言
 */
export async function sendSigninwallMessage(params) {
    return request({url: signinwallMessage, method: 'post', data: params,})
}

/**
 * 发送留言
 */
export async function findSigninwallMessageRecent(params) {
    return request({url: signinwallMessageRecents, method: 'get', data: params,})
}
export async function deleteSigninwallMessageRecent(params) {
    return request({url: signinwallMessageRecent, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/signinwall.js